import { render } from "./emploiFruits.vue?vue&type=template&id=91fa0f66"
import script from "./emploiFruits.vue?vue&type=script&lang=js"
export * from "./emploiFruits.vue?vue&type=script&lang=js"

import "./emploiFruits.vue?vue&type=style&index=0&id=91fa0f66&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__